import {useMutation} from '@tanstack/react-query'
import {
    HttpRequestVerificationCodeOptions,
    httpRequestVerificationPhoneCode
} from '@features/settings/http/settings.http.ts'
import {errorHandler} from '@utilities/helpers.ts'

export const useRequestVerificationPhoneCode = ({onSuccess}: {onSuccess: () => void}) => {
    return useMutation<unknown, unknown, HttpRequestVerificationCodeOptions>({
        mutationFn: variables => httpRequestVerificationPhoneCode(variables),
        onError: errorHandler,
        onSuccess
    })
}
